import LocationsList from './LocationsList';
import './LocationsList.scss';

export default LocationsList;
